import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IVersionNameField {
	changeVersionName: (value: string) => void;
}

const VersionNameField: React.FC<IVersionNameField> = ({ changeVersionName }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterVersionName') }], [t]);

	return (
		<FormInput
			testId="VersionNameField"
			name="versionName"
			label="versionNameLabel"
			maxLength={50}
			onChange={changeVersionName}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(VersionNameField);
